import { useState, useEffect } from "react";
import i18n from "i18next";
import { Modal } from "react-bootstrap";
import enIcon from "../../Asset/image/home/EN_FLAG.png";
import thIcon from "../../Asset/image/home/TH_FLAG.png";
import Close_x from "../../Asset/icon/closeButton.svg";
import circleFrame from "../../Asset/icon/WhitecircleFrame.svg";
import { useTranslation } from "react-i18next";

function ModalLang({ show, onHide, onLangChange, updateLanguageIcon }) {
  const [currentLanguage, setCurrentLanguage] = useState(i18n.language);
  const [selectedLanguage, setSelectedLanguage] = useState(
    localStorage.getItem("selectedLanguage") || "en"
  );

  useEffect(() => {
    setCurrentLanguage(i18n.language);
  }, [i18n.language]);

  useEffect(() => {
    setPreviewText(
      currentLanguage === "en"
        ? "Click to switch language"
        : "กดเพื่อเปลี่ยนภาษา"
    );
  }, [currentLanguage]);

  const handleLanguageSelect = (language) => {
    i18n.changeLanguage(language);
    setCurrentLanguage(language);
    setSelectedLanguage(language);
    localStorage.setItem("selectedLanguage", language);
    onHide();
  };

  const [previewText, setPreviewText] = useState(
    currentLanguage === "en" ? "Click to switch language" : "กดเพื่อเปลี่ยนภาษา"
  );

  const [isHoveringEN, setIsHoveringEN] = useState(false);
  const [isHoveringTH, setIsHoveringTH] = useState(false);

  const handleMouseEnterEN = () => {
    setIsHoveringEN(true);
  };

  const handleMouseLeaveEN = () => {
    setIsHoveringEN(false);
  };

  const handleMouseEnterTH = () => {
    setIsHoveringTH(true);
  };

  const handleMouseLeaveTH = () => {
    setIsHoveringTH(false);
  };

  const handleLanguagePreview = (language) => {
    setPreviewText(
      language === "en" ? "Click to switch language" : "กดเพื่อเปลี่ยนภาษา"
    );
  };

  return (
    <div>
      <Modal
        show={show}
        fullscreen
        onHide={onHide}
        className="pr-0"
      >
        <img
          src={Close_x}
          alt="CloseBtn"
          onClick={onHide}
          className="abs-top-right"
        />
        <Modal.Body
          className="flex-evenly-center"
        >
          <div
            className="fs-1 sticky-top"
          >
            {previewText}
          </div>
        </Modal.Body>
        <Modal.Body
          className="no-border flex-center2 relative"
        >
          <div
            className="flex-center3 mr-5vw"
          >
            <img
              draggable={false}
              src={enIcon}
              alt="enIcon"
              className="img-clickable"
              onClick={() => handleLanguageSelect("en")}
              onMouseEnter={() => {
                handleLanguagePreview("en");
                handleMouseEnterEN();
              }}
              onMouseLeave={handleMouseLeaveEN}
            />
            {isHoveringEN && (
              <img
                draggable={false}
                src={circleFrame}
                alt="circleFrame"
                className="abs-img-offset"
              />
            )}
          </div>
          <div
           className="flex-center4 ml-5vw"
          >
            <img
              src={thIcon}
              alt="thIcon"
              className="img-clickable"
              onClick={() => handleLanguageSelect("th")}
              draggable={false}
              onMouseEnter={() => {
                handleLanguagePreview("th");
                handleMouseEnterTH();
              }}
              onMouseLeave={handleMouseLeaveTH}
            />
            {isHoveringTH && (
              <img
                draggable={false}
                src={circleFrame}
                alt="circleFrame"
                className="abs-img-offset"
              />
            )}
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default ModalLang;
